import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MenuPopup = ({
  anchorName,
  menuItems,
  menuOpen,
  setCurrentOpenPopup,
  id,
}) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() => {
        if (menuOpen) setCurrentOpenPopup(null);
        else setCurrentOpenPopup(id);
      }}
      onMouseLeave={() => {
        setCurrentOpenPopup(null);
      }}
      className="relative inline-block text-left text-inherit">
      <div className="flex items-center text-inherit">
        <div
          className="text-inherit font-inherit hover:text-[#CDCBFF] transition-colors hover:opacity-[100%]"
          aria-haspopup="true"
          aria-expanded="true">
          {anchorName}
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className={`w-4 h-4 transition-all duration-300 ml-1	${
            menuOpen && "rotate-180"
          }`}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>

      <div className="">
        {menuOpen && (
          <div
            className="origin-top-right absolute left-0 rounded-md shadow-lg bg-white ring-5 ring-black ring-opacity-5 animate-expandDown flex  bg-white rounded-md shadow-md py-4 gap-4"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu">
            <ol className="">
              {menuItems.map((item, index) => (
                <li
                  onClick={() => {
                    setCurrentOpenPopup(null);
                    navigate(item.path);
                  }}
                  key={index}
                  className="block px-8 py-2 text-gray-700 hover:text-black hover:bg-gray-100 whitespace-nowrap text-[15.5px] flex items-center">
                  <div className="w-full text-inherit">{item.name}</div>
                </li>
              ))}
            </ol>
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuPopup;
